import React, { useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import './Portal.css';

export function useTabParam(ids, param = 'tab') {
  const [params, setParams] = useSearchParams();
  const requested = params.get(param);
  const value = ids.includes(requested) ? requested : ids[0];
  const change = (id) => {
    const next = new URLSearchParams(params);
    if (id === ids[0]) next.delete(param); else next.set(param, id);
    setParams(next, { replace: true });
  };
  return [value, change];
}

export default function Tabs({ label, tabs, value, onChange }) {
  const refs = useRef({});
  const active = tabs.find((tab) => tab.id === value) || tabs[0];
  const move = (event, index) => {
    const offsets = { ArrowRight: 1, ArrowLeft: -1 };
    let nextIndex;
    if (event.key in offsets) nextIndex = (index + offsets[event.key] + tabs.length) % tabs.length;
    else if (event.key === 'Home') nextIndex = 0;
    else if (event.key === 'End') nextIndex = tabs.length - 1;
    else return;
    event.preventDefault();
    onChange(tabs[nextIndex].id);
    refs.current[tabs[nextIndex].id]?.focus();
  };
  return <>
    <div className="portal-tablist" role="tablist" aria-label={label}>
      {tabs.map((tab, index) => <button key={tab.id} type="button" role="tab" className="portal-tab"
        id={`tab-${tab.id}`} aria-controls={`tabpanel-${tab.id}`} aria-selected={tab.id === active.id}
        tabIndex={tab.id === active.id ? 0 : -1} ref={(node) => { refs.current[tab.id] = node; }}
        onClick={() => onChange(tab.id)} onKeyDown={(event) => move(event, index)}>{tab.label}</button>)}
    </div>
    <div role="tabpanel" id={`tabpanel-${active.id}`} aria-labelledby={`tab-${active.id}`}>{active.content}</div>
  </>;
}
